import React, {useState} from "react";
import {
    Modal,
    Form,
    Row,
    Col,
    Button,
    DatePicker,
    Upload
} from "antd";
import {AxiosError} from "axios";
import {ErrorResponseData} from "../../../../../models/core/response";
import {useNavigate} from "react-router";
import {useTranslate} from "../../../../../hooks/translate.hook";
import dayjs from "dayjs";
import {UploadDailyStatement} from "../../../../../models/accounting/daily-statements";
import {dailyStatementService} from "../../../../../services/accounting/daily-statement.service";

interface ReportsAccountingMonthlyStatementsUploadModalProps {
    visible: boolean;
    onClose: () => void;
    onSubmit: (report: any) => void;
}

interface FormValue {
    file: File;
    month: dayjs.Dayjs;
}

export const ReportsAccountingMonthlyStatementsUploadModal: React.FC<ReportsAccountingMonthlyStatementsUploadModalProps> = ({ visible, onClose, onSubmit }) => {
    const t = useTranslate();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm<FormValue>();

    return (
        <Modal
            visible={visible}
            confirmLoading={loading}
            style={{top: 20}}
            title={t("REPORTS.ACCOUNTING.MONTHLY-STATEMENTS.UPLOAD.TITLE")}
            okText={t("REPORTS.ACCOUNTING.MONTHLY-STATEMENTS.UPLOAD.TITLE")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                size={"middle"}
                form={form}
                layout="vertical"
                name={"client_form"}
                initialValues={{}}
                onFinish={() =>
                    form.validateFields().then((values) => {
                        setLoading(true);

                        const dto: UploadDailyStatement = {
                            file:  values.file
                        }

                        dailyStatementService.uploadStatement(dto)
                            .then(
                                (result) => {
                                    form.resetFields();
                                    onClose();
                                    navigate("/accounting/daily-statements/" + result.id);
                                },
                                (e: AxiosError<ErrorResponseData>) => {
                                    if (e.response?.data.fields) {
                                        form.setFields(e.response?.data?.fields);
                                    }
                                }
                            )
                            .finally(() => setLoading(false));
                    })
                }
            >
                <Row gutter={[30, 0]} align={"top"}>
                    <Col xxl={24} xl={24} md={24} sm={24} xs={24}>
                        <Row gutter={[10, 0]} align="middle">
                            <Col span={24}>
                                <Form.Item
                                    name={["file"]}
                                    valuePropName={""}
                                    getValueFromEvent={e => e.file}
                                    label={t("FILE")}
                                    help={"XML File"}
                                    rules={[
                                        {
                                            required: true,
                                            message: t("FROM.ERROR.PLEASE_SELECT_VALUE"),
                                        },
                                    ]}
                                >
                                    <Upload
                                        maxCount={1}
                                        accept={".xml"}
                                        beforeUpload={() => false}
                                    >
                                        <Button>Click to upload</Button>
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}